import { Vue, Component } from 'vue-property-decorator'
import { CreateElement } from 'vue'
import LinkArrowSvg from '~/assets/svg/main-slider-link-arrow.svg?inline'
import loc from '~/utils/loc'

@Component
export default class MainInfoBlock extends Vue {
  render (h: CreateElement) {
    return (
      <div class="main-info-block">
        <div class="main-info-block__row">
          <div class="main-info-block__col-image">
            <div class="main-info-block__image">
              {h('img', { attrs: { src: require('~/assets/image/index-info.jpg') } })}
            </div>
          </div>
          <div class="main-info-block__col-content">
            <h1 class="main-info-block__header">
              Интернет-аптека 24farmacia.ru
            </h1>
            <div class="main-info-block__text">
              Сеть аптек &laquo;Губернские аптеки&raquo; является одной из&nbsp;крупнейших региональных аптечных сетей России. Она объединяет аптеки, аптечные пункты и&nbsp;киоски, ортопедические салоны, салоны оптики, гомеопатический центр и&nbsp;ветеринарные аптеки, расположенных на&nbsp;территории всего Красноярского края.            </div>
            <nuxt-link to={loc(this.$store, { name: 'help-pharmacy' })} class="main-info-block__link">
              <div class="main-info-block__link-arrow">
                <LinkArrowSvg />
              </div>
              <div class="main-info-block__link-text">
                Подробнее
              </div>
            </nuxt-link>
          </div>
        </div>
      </div>
    )
  }
}
